export const ingestMonitor = {
  title: { en: 'Ingestion Monitoring', ko: '수집 모니터링', fr: '' },
  description: {
    en: 'Live ingestion status per device.',
    ko: '기기별 실시간 수집 상태입니다.',
    fr: '',
  },

  // table columns
  manufacturer: { en: 'Manufacturer', ko: '제조사', fr: '' },
  model: { en: 'Model', ko: '모델', fr: '' },
  deviceSerial: { en: 'Device serial', ko: '기기 시리얼', fr: '' },
  patientName: { en: 'Patient', ko: '환자', fr: '' },
  lastIngestedTime: { en: 'Last ingested', ko: '마지막 수집 시각', fr: '' },
  status: { en: 'Status', ko: '상태', fr: '' },
  never: { en: 'Never', ko: '없음', fr: '' },

  // filters
  searchSerial: { en: 'Search device serial', ko: '기기 시리얼 검색', fr: '' },
  rowsPerPage: { en: 'Rows', ko: '행 수', fr: '' },
  refreshInterval: { en: 'Auto refresh', ko: '자동 새로고침', fr: '' },
  seconds: { en: 's', ko: '초', fr: '' },

  // status tooltips
  statusFresh: { en: 'Ingested within the last 2 minutes', ko: '최근 2분 이내 수집됨', fr: '' },
  statusStale: { en: 'No ingestion in the last 2 minutes', ko: '최근 2분 이내 수집 없음', fr: '' },

  empty: { en: 'No devices found.', ko: '기기를 찾을 수 없습니다.', fr: '' },

  // delete
  actions: { en: 'Actions', ko: '작업', fr: '' },
  delete: { en: 'Delete', ko: '삭제', fr: '' },
  confirmDeleteTitle: { en: 'Delete row', ko: '항목 삭제', fr: '' },
  confirmDeleteMessage: {
    en: 'Delete this ingestion monitoring entry? This cannot be undone.',
    ko: '이 수집 모니터링 항목을 삭제하시겠습니까? 되돌릴 수 없습니다.',
    fr: '',
  },
};
